export const QRTrackConstants = {
    // 🔍 QR Scan Info
    TRACK_SCAN_INFO_REQUEST: "TRACK_SCAN_INFO_REQUEST",
    TRACK_SCAN_INFO_SUCCESS: "TRACK_SCAN_INFO_SUCCESS",
    TRACK_SCAN_INFO_FAILURE: "TRACK_SCAN_INFO_FAILURE",
  
    // 🔁 Toggle (ID-based fetch)
    TRACK_TOGGLE_REQUEST: "TRACK_TOGGLE_REQUEST",
    TRACK_TOGGLE_SUCCESS: "TRACK_TOGGLE_SUCCESS",
    TRACK_TOGGLE_FAILURE: "TRACK_TOGGLE_FAILURE",
  
    // 🔁 Toggle 2 (Secondary toggle)
    TRACK_TOGGLE_2_REQUEST: "TRACK_TOGGLE_2_REQUEST",
    TRACK_TOGGLE_2_SUCCESS: "TRACK_TOGGLE_2_SUCCESS",
    TRACK_TOGGLE_2_FAILURE: "TRACK_TOGGLE_2_FAILURE",
  
    // 📜 Journey Tracking Info
    TRACK_JOURNEY_INFO_REQUEST: "TRACK_JOURNEY_INFO_REQUEST",
    TRACK_JOURNEY_INFO_SUCCESS: "TRACK_JOURNEY_INFO_SUCCESS",
    TRACK_JOURNEY_INFO_FAILURE: "TRACK_JOURNEY_INFO_FAILURE",
  
    // ⏳ Generic loading (optional usage)
    LOADING_REQUEST: "LOADING_REQUEST",
  };
  